<wuc-card cardStyle="secondary" borderWidth="none" padding="large">
    <!-- Insurance coverage -->
    <ins-insurance-coverage
        *ngIf="purchasedProduct"
        [purchasedProduct]="purchasedProduct"
        [relation]="relation"
    ></ins-insurance-coverage>
</wuc-card>
<wuc-card cardStyle="secondary" borderWidth="none" padding="large">
    <h3>Polisgegevens</h3>
    <!-- Insurance general topics -->
    <wuc-rack *ngIf="purchasedProduct" gridGap="medium" class="insurance-terms-and-conditions">
        <ins-insurance-start-date *ngIf="purchasedProduct" [purchasedProduct]="purchasedProduct"></ins-insurance-start-date>
        <ins-insurance-end-product
            *ngIf="purchasedProduct"
            [purchasedProduct]="purchasedProduct"
        ></ins-insurance-end-product>

    <ins-insurance-terms-and-conditions
        *ngIf="purchasedProduct"
        [relation]="relation"
        [purchasedProduct]="purchasedProduct"
    ></ins-insurance-terms-and-conditions>
    </wuc-rack>
    <!-- Insurance details -->
    <ins-insurance-bicycle *ngIf="isBicycle" [purchasedProduct]="purchasedProduct"></ins-insurance-bicycle>
    <ins-insurance-car *ngIf="isCar" [purchasedProduct]="purchasedProduct"></ins-insurance-car>
    <ins-insurance-caravan *ngIf="isCaravan" [purchasedProduct]="purchasedProduct"></ins-insurance-caravan>
    <ins-insurance-home *ngIf="isHome" [purchasedProduct]="purchasedProduct"></ins-insurance-home>
    <ins-insurance-moped *ngIf="isMoped" [purchasedProduct]="purchasedProduct"></ins-insurance-moped>
    <ins-insurance-motorcycle *ngIf="isMotorcycle" [purchasedProduct]="purchasedProduct"></ins-insurance-motorcycle>
    <ins-insurance-pet *ngIf="isPet" [purchasedProduct]="purchasedProduct"></ins-insurance-pet>
    <!-- Insurance specific topics -->
    <ins-insurance-regular-driver
        *ngIf="hasRegularDriver"
        [purchasedProduct]="purchasedProduct"
    ></ins-insurance-regular-driver>
    <ins-insurance-premium-determining-factors
        *ngIf="hasPremiumDeterminingFactors"
        [purchasedProduct]="purchasedProduct"
    ></ins-insurance-premium-determining-factors>
    <ins-insurance-imic
        *ngIf="hasInternationalMotorInsuranceCard"
        [purchasedProduct]="purchasedProduct"
    ></ins-insurance-imic>
</wuc-card>
